import { COMPLAINS_FETCH_SUCCESS } from '../constant/actionType';

const initialState = {
  complains: [],
  isLoaded: false
};

const complainsReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLAINS_FETCH_SUCCESS:
      return {
        ...state,
        complains: action.data,
        isLoaded: true
      };
    default:
      return state;
  }
};

export default complainsReducer;
